<div (mouseenter)="this.dotComService.DisplaySubMenu('')">

  <!-- login Modal -->
  <app-myharrellsloginprompt></app-myharrellsloginprompt>
  <!-- End login Modal -->

  <div class="headerImageHeight4" style="background-size: cover; background-position:center"
    [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'education-header.jpg)'}">
    <div class="row">
      <div style="width:10%"></div>
      <div *ngIf="myHarrellsService.bootstrapViewPortSize != ''" class="text-center whiteText" style="width:80%">
        <h1
          *ngIf="myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'"
          class="DINNextLTPro-Black whiteText headerImageTextLarge" style="text-transform: uppercase;">EDUCATION</h1>
        <h1
          *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
          class="DINNextLTPro-Black whiteText headerImageTextLarge2" style="text-transform: uppercase;">ONLINE COURSES
          TO ENHANCE YOUR GROWTH</h1>
      </div>
      <div style="width:10%"></div>
    </div>
  </div>

  <div class="row mt-5" style="max-width:1200px; margin:auto">
    <div
      *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
      class="col-3" style="padding-right:70px; margin-left:30px;">
      <h3 CLASS="DIN2014Bold blackText mb-3"
        style=" font-size:26px; line-height: normal; font-weight: 700; text-align: left;  margin-bottom:0pt">
        Education</h3>
      <div style="width:100%">
        <input Class="DIN2014Regular educationSearchInput" placeholder="Search Here" (keyup)="SearchEducationFired()"
          [(ngModel)]="this.educationSearchKey">
        <img src="{{this.pageImagePaths + 'search-normal.png'}}" alt="Search Icon"
          style="cursor:pointer;display:inline;margin-left:-30px">
      </div>
      <div class="filterContainer">
        <!-- left part of screen with filters -->
        <h4 CLASS="DIN2014Bold"
          style="cursor:pointer;font-size:19px; line-height: 30px; font-weight: 700; color:#006890; text-align: left; margin-bottom:0pt; margin-top:20px"
          (click)="DisplayAllEducationPosts()">ALL</h4>
        <h4 CLASS="DIN2014Bold" (click)="ToggleExpand('CourseType')"
          style=" font-size:19px; line-height: 30px; font-weight: 700; color:#006890; text-align: left; margin-bottom:0pt; margin-top:0px;">
          Course Type
        </h4>
        <div *ngIf="topicsExpanded">
          <div style="text-align: left; margin-left:10px;">
            <label>
              <input type="checkbox" class="checkbox-round" id='CEU' style="width:10px; height:10px"
                (change)="EducationTypeCheckboxChanged('CEU',$event)">
              <h6 class="DIN2014Regular"
                style="display:inline-block;font-size:16px; font-weight:700; line-height:30px; color:#027D3C; margin-bottom:0; margin-left:5px">
                CEU</h6>
            </label>

            <div>
              <select class="DIN2014Regular" style="display:inline;font-size:16px;line-height:20px;letter-spacing: .32px; gap:10px; align-items: center;height:40px; width:80%; padding-left:10px; margin-left:20px; margin-top:10px; margin-bottom:10px;
                  align-items: center; gap: 10px; backdrop-filter: blur(2.5px);" [(ngModel)]="this.selectedState"
                (ngModelChange)="StateChanged($event)">
                <option class="DIN2014Regular" style="font-size:16px; line-height: 20px; letter-spacing:.32px" value="">
                  All States</option>
                <option *ngFor="let stateId of allStates" class="DIN2014Regular"
                  style="font-size:16px; line-height: 20px; letter-spacing:.32px" value="{{stateId}}">
                  {{stateId | uppercase}}</option>
              </select>
            </div>


          </div>

          <div style="text-align: left; margin-left:10px;">
            <label>
              <input type="checkbox" class="checkbox-round" id='FNGLA' style="width:10px; height:10px"
                (change)="EducationTypeCheckboxChanged('FNGLA',$event)">
              <h6 class="DIN2014Regular"
                style="display:inline-block;font-size:16px; font-weight:700; line-height:30px; color:#027D3C; margin-bottom:0; margin-left:5px">
                FNGLA</h6>
            </label>
          </div>

          <div style="text-align: left; margin-left:10px;">
            <label>
              <input type="checkbox" class="checkbox-round" id='GCSAA' style="width:10px; height:10px"
                (change)="EducationTypeCheckboxChanged('GCSAA',$event)">
              <h6 class="DIN2014Regular"
                style="display:inline-block;font-size:16px; font-weight:700; line-height:30px; color:#027D3C; margin-bottom:0; margin-left:5px">
                GCSAA</h6>
            </label>
          </div>

          <div style="text-align: left; margin-left:10px;">
            <label>
              <input type="checkbox" class="checkbox-round" id='CCA' style="width:10px; height:10px"
                (change)="EducationTypeCheckboxChanged('CCA',$event)">
              <h6 class="DIN2014Regular"
                style="display:inline-block;font-size:16px; font-weight:700; line-height:30px; color:#027D3C; margin-bottom:0; margin-left:5px">
                CCA</h6>
            </label>
          </div>

          <div style="text-align: left; margin-left:10px;">
            <label>
              <input type="checkbox" class="checkbox-round" id='Spanish' style="width:10px; height:10px"
                (change)="EducationTypeCheckboxChanged('Spanish',$event)">
              <h6 class="DIN2014Regular"
                style="display:inline-block;font-size:16px; font-weight:700; line-height:30px; color:#027D3C; margin-bottom:0; margin-left:5px">
                Spanish</h6>
            </label>
          </div>


          <h4 CLASS="DIN2014Bold" (click)="ToggleExpand('CourseType')"
            style=" font-size:19px; line-height: 30px; font-weight: 700; color:#006890; text-align: left; margin-bottom:0pt; margin-top:0px;">
            Category
          </h4>

          <div>
            <select class="DIN2014Regular" style="display:inline;font-size:16px;line-height:20px;letter-spacing: .32px; gap:10px; align-items: center;height:40px; width:80%; padding-left:10px; margin-left:10px; margin-top:10px; margin-bottom:10px;
                align-items: center; gap: 10px; backdrop-filter: blur(2.5px);" [(ngModel)]="this.selectedCategory"
              (ngModelChange)="CategoryChanged($event)">
              <option class="DIN2014Regular" style="font-size:16px; line-height: 20px; letter-spacing:.32px" value="">
                All Courses</option>
              <option *ngFor="let categoryId of allCategories" class="DIN2014Regular"
                style="font-size:16px; line-height: 20px; letter-spacing:.32px" value="{{categoryId}}">
                {{categoryId | titlecase }}</option>
            </select>
          </div>
        </div>
      </div>

    </div>
    <div class="col mainBody">
      <div class="row searchContainer">
        <div class="col-9 text-start">
          <input
            *ngIf="this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'"
            Class="DIN2014Regular educationSearchInput" placeholder="Search Here" (keyup)="SearchEducationFired()"
            [(ngModel)]="this.educationSearchKey">
          <img
            *ngIf="this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'"
            src="{{this.pageImagePaths + 'search-normal.png'}}" alt="Search Icon"
            style="cursor:pointer;display:inline;margin-left:-30px">

          <img
            *ngIf="this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'"
            src="{{baseImagePaths + 'FilterIconDark.png'}}"
            style="cursor:pointer; width:60px; height:40px; position:absolute; right:20px" alt="filter icon"
            (click)="ToggleFilter()">

          <div class="col-lg-3 filterContainer"
            *ngIf="showFilterObjects && myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && (myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">
            <!-- left part of screen with filters -->
            <h4 CLASS="DIN2014Bold"
              style="font-size:19px; line-height: 30px; font-weight: 700; color:#006890; text-align: left; margin-left:10px; margin-bottom:0pt; margin-top:20px; padding-right:30%"
              (click)="DisplayAllEducationPosts()">ALL</h4>
            <h4 CLASS="DIN2014Bold" (click)="ToggleExpand('CourseType')"
              style=" font-size:19px; line-height: 30px; font-weight: 700; color:#006890; text-align: left; margin-left:10px; margin-bottom:0pt; margin-top:0px; padding-right:30%">
              Course Type
            </h4>
            <!-- <div *ngIf="topicsExpanded">
              <div *ngFor="let ceuType of CEUTypes" style="text-align: left; margin-left:25%;">
                <label [ngStyle]="(ceuType != 'CEU' && ceuType != 'GCSAA')?{'margin-left': '20px'}:null">
                  <input type="checkbox" class="checkbox-round" [id]="ceuType" style="width:10px; height:10px"
                    (change)="EducationTypeCheckboxChanged(ceuType,$event)">
                  <h6 class="DIN2014Regular"
                    style="display:inline-block;font-size:16px; font-weight:700; line-height:30px; color:#027D3C; margin-bottom:0; margin-left:5px">
                    {{ceuType}}</h6>
                </label>
              </div>
            </div> -->


            <div *ngIf="topicsExpanded">
              <div style="text-align: left; margin-left:10px;">
                <label>
                  <input type="checkbox" class="checkbox-round" id='CEU' style="width:10px; height:10px"
                    (change)="EducationTypeCheckboxChanged('CEU',$event)">
                  <h6 class="DIN2014Regular"
                    style="display:inline-block;font-size:16px; font-weight:700; line-height:30px; color:#027D3C; margin-bottom:0; margin-left:5px">
                    CEU</h6>
                </label>

                <div>
                  <select class="DIN2014Regular" style="display:inline;font-size:16px;line-height:20px;letter-spacing: .32px; gap:10px; align-items: center;height:40px; width:80%; padding-left:10px; margin-top:10px; margin-bottom:10px;
                  align-items: center; gap: 10px; backdrop-filter: blur(2.5px);" [(ngModel)]="this.selectedState"
                    (ngModelChange)="StateChanged($event)">
                    <option class="DIN2014Regular" style="font-size:16px; line-height: 20px; letter-spacing:.32px"
                      value="">
                      All States</option>
                    <option *ngFor="let stateId of allStates" class="DIN2014Regular"
                      style="font-size:16px; line-height: 20px; letter-spacing:.32px" value="{{stateId}}">
                      {{stateId | uppercase}}</option>
                  </select>
                </div>


              </div>

              <div style="text-align: left; margin-left:10px;">
                <label>
                  <input type="checkbox" class="checkbox-round" id='FNGLA' style="width:10px; height:10px"
                    (change)="EducationTypeCheckboxChanged('FNGLA',$event)">
                  <h6 class="DIN2014Regular"
                    style="display:inline-block;font-size:16px; font-weight:700; line-height:30px; color:#027D3C; margin-bottom:0; margin-left:5px">
                    FNGLA</h6>
                </label>
              </div>

              <div style="text-align: left; margin-left:10px;">
                <label>
                  <input type="checkbox" class="checkbox-round" id='GCSAA' style="width:10px; height:10px"
                    (change)="EducationTypeCheckboxChanged('GCSAA',$event)">
                  <h6 class="DIN2014Regular"
                    style="display:inline-block;font-size:16px; font-weight:700; line-height:30px; color:#027D3C; margin-bottom:0; margin-left:5px">
                    GCSAA</h6>
                </label>
              </div>

              <div style="text-align: left; margin-left:10px;">
                <label>
                  <input type="checkbox" class="checkbox-round" id='CCA' style="width:10px; height:10px"
                    (change)="EducationTypeCheckboxChanged('CCA',$event)">
                  <h6 class="DIN2014Regular"
                    style="display:inline-block;font-size:16px; font-weight:700; line-height:30px; color:#027D3C; margin-bottom:0; margin-left:5px">
                    CCA</h6>
                </label>
              </div>

              <div style="text-align: left; margin-left:10px;">
                <label>
                  <input type="checkbox" class="checkbox-round" id='Spanish' style="width:10px; height:10px"
                    (change)="EducationTypeCheckboxChanged('Spanish',$event)">
                  <h6 class="DIN2014Regular"
                    style="display:inline-block;font-size:16px; font-weight:700; line-height:30px; color:#027D3C; margin-bottom:0; margin-left:5px">
                    Spanish</h6>
                </label>
              </div>


              <h4 CLASS="DIN2014Bold" (click)="ToggleExpand('CourseType')"
                style=" font-size:19px; line-height: 30px; font-weight: 700; color:#006890; text-align: left; margin-bottom:0pt; margin-top:0px;margin-left:10px">
                Category
              </h4>

              <div>
                <select class="DIN2014Regular" style="display:inline;font-size:16px;line-height:20px;letter-spacing: .32px; gap:10px; align-items: center;height:40px; width:80%; padding-left:10px; margin-left:10px; margin-top:10px; margin-bottom:10px;
                align-items: center; gap: 10px; backdrop-filter: blur(2.5px);" [(ngModel)]="this.selectedCategory"
                  (ngModelChange)="CategoryChanged($event)">
                  <option class="DIN2014Regular" style="font-size:16px; line-height: 20px; letter-spacing:.32px"
                    value="">
                    All Courses</option>
                  <option *ngFor="let categoryId of allCategories" class="DIN2014Regular"
                    style="font-size:16px; line-height: 20px; letter-spacing:.32px" value="{{categoryId}}">
                    {{categoryId | titlecase }}</option>
                </select>
              </div>
            </div>

          </div>
        </div>
        <div class="col-3">
        </div>
      </div>
      <div class="mb-5">

        <div *ngFor="let row of this.courseListFiltered" style="text-align: left">
          <div class="row mt-3" (click)="GoToEducationCourse(row)" style="cursor:pointer">
            <div class="postContentContainer">
              <img class="darkenImage imageContainer"
                *ngIf="(!this.loggedInToMyHarrells && row.IsMatrixPost && !row.isMatrixPublicCourse)"
                src={{row.ImageName}} alt="post image">
              <div *ngIf="(!this.loggedInToMyHarrells && row.IsMatrixPost && !row.isMatrixPublicCourse)"
                style="position:relative; top:-100px; left:50px; text-align: center; width:150px;">
                <h6 class="DIN2014Regular whiteText" style="font-size:19px;margin:auto; background-color:black">
                  Log In Required
                </h6>
              </div>
              <img class="imageContainer" *ngIf="(this.loggedInToMyHarrells && row.IsMatrixPost ) 
                || (this.loggedInToMyHarrells && !row.IsMatrixPost) 
                || (!this.loggedInToMyHarrells && row.IsMatrixPost && row.isMatrixPublicCourse) 
                || (!this.loggedInToMyHarrells && !row.IsMatrixPost) " src={{row.ImageName}} alt="post image">
            </div>
            <div class="postTextHeaderContainer">
              <h3 class="DIN2014Bold" style="font-size:19px; line-height:23px; letter-spacing: .38px;">
                {{this.dotComService.HtmlStringToPlainText( row.Title)}}</h3>
              <h4 class="DIN2014Regular" style="font-size:14px; line-height: 19px;font-weight:400; color: #131313;"
                [innerHTML]="row.Summary">
              </h4>
              <!-- <h5 class="DIN2014Regular greenText" *ngIf="(this.loggedInToMyHarrells && row.IsMatrixPost) 
                || (this.loggedInToMyHarrells && !row.IsMatrixPost) 
                || (!this.loggedInToMyHarrells && !row.IsMatrixPost) "
                style="cursor:pointer; margin-top:20px; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;"
                >
                READ ARTICLE ></h5> -->
              <h5 class="DIN2014Regular greenText" *ngIf="!row.IsMatrixPost"
                style="cursor:pointer; margin-top:20px; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                READ ARTICLE ></h5>
              <h5 class="DIN2014Regular greenText " *ngIf="(this.loggedInToMyHarrells && row.IsMatrixPost) "
                style="cursor:pointer; margin-top:20px; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                VIEW COURSE ></h5>
              <h5 class="DIN2014Regular greenText "
                *ngIf="(!this.loggedInToMyHarrells && row.IsMatrixPost && !row.isMatrixPublicCourse) "
                style="cursor:pointer; margin-top:20px; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                LOG IN TO VIEW COURSE ></h5>
              <h5 class="DIN2014Regular greenText "
                *ngIf="(!this.loggedInToMyHarrells && row.IsMatrixPost && row.isMatrixPublicCourse) "
                style="cursor:pointer; margin-top:20px; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                VIEW PUBLIC COURSE ></h5>
            </div>
          </div>
        </div>
        <h3 *ngIf="!this.disableMoreButton" class="lightBlueBackground"
          style="margin-top:3%; max-width:130px; text-align: center;" (click)="GetNextGroupOfEducationPosts()">
          <a class="DINNextLTPro-Black blueText "
            style="line-height:2; font-size:20px; text-decoration: none !important">LOAD MORE</a>
        </h3>

      </div>
    </div>
  </div>
</div>


<!-- THIS WAS MOVED TO THE MATRIX.HTML PAGE  -->
<!-- <a (click)="LogUserIntoMatrixAndGoToCourse()">

  <h3 style="text-align:center;color:blue;cursor:pointer; margin-top:50px; margin-bottom:50px">Demo - SSO with a
    MyHarrells user and Matrix</h3>
  <h5 style="text-align:center;color:blue;cursor:pointer; margin-top:50px; margin-bottom:50px">Testing with
    accounting&#64;canoaranchgolfclub.com</h5>
</a>
<div style="text-align:center;">
  <h6 style="margin-bottom: 50px;">If the Matrix account is not set up this will create the account as a Learner, enroll
    them in the class if not already enrolled, forward the user to the Matrix site and log them in. If the Matrix
    account exists it will just enroll them in the class if not enrolled, forward the user and
    log them in.
  </h6>
</div>


<div id="lms_widget_container" style="position:fixed; top: -500px; left:-500px">
  <div id="lms_widget_header">
    <h1>Online School</h1>
  </div>

  <div id="lms_widget_inner">


    <form name="form1" method="post" action="https://harrells.matrixlms.com/log_in/submit" target="_blank">
      <label for="userid">User ID</label>
      <input type="text" name="userid" id="userid" class="lms_widget_border">

      <label for="password">Password</label>
      <a href="http://harrells.matrixlms.com/log_in/forgot_password" target="_blank">(forgot?)</a><br>
      <input type="password" name="password" id="password" class="lms_widget_border"><br>

      <button type="submit" id="submitButton" value="Submit">Log in</button>

      <input type="checkbox" name="remember" id="remember">
      <label for="remember">Remember me?</label>
    </form>
  </div>
</div> -->
<!-- this will always stay hidden from tue user  -->

<!-- 
<h1 style="text-align:center;border-top:solid 1px gray">Matrix Courses?</h1>
<div *ngFor="let course of matrixCourseList">
  <div style="text-align:center;">
    <h6>{{course.name}}</h6>
  </div>
  </div>   -->